import { render, staticRenderFns } from "./StudentSettings.vue?vue&type=template&id=1f7f63ce&scoped=true&"
import script from "./StudentSettings.vue?vue&type=script&lang=js&"
export * from "./StudentSettings.vue?vue&type=script&lang=js&"
import style0 from "./StudentSettings.vue?vue&type=style&index=0&id=1f7f63ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7f63ce",
  null
  
)

export default component.exports